// New version of "Sök räntor och valutakurser"
import { isDuetDateValidFunction as isDuetDateValid } from "./duet-date-picker";

global.InterestPageAstrid = (function ($) {
	function init(data) {
		var currencyList = new Array();
		var interestsList = new Array();
		var indexList = new Array();
		const arrayMaxLength = 10;
		const arraysObj = { 1: currencyList, 2: interestsList, 3: indexList }
		const currencyForm = document.getElementById('riksbank-seriesform');
		// # Step 2
		const freqDay = document.getElementById('D');
		const calculationMethods = document.getElementsByClassName("js-calculation-method");
		const calculationMethodElement = document.getElementById("js-calculation-methods");
		const getCheckedCheckboxes = document.querySelectorAll('input[type="checkbox"]:checked');
		const getSumary = document.getElementById('summary-fe');

		if (getSumary) {
			for (let getCheckedCheckbox of getCheckedCheckboxes) {
				addtoArray(getCheckedCheckbox.dataset.description, getCheckedCheckbox.dataset.parentid);
			}
		}

		if (freqDay && !freqDay.checked) {
			showDomElement(calculationMethodElement, true)
		}

		function getTargetArray(key) {
			let whatArray = arraysObj[key];
			return whatArray;
		}

		function addtoArray(value, parentId) {
			let array = getTargetArray(parentId);

			if (!array.includes(value) && value != "toggle-all") {
				array.push(value);
				array.sort();
				updateInterface(array, parentId);
			}
		}

		function removefromArray(event, value, parentId) {
			let array = getTargetArray(parentId);
			let checkedGroup = event.target.dataset.group;
			let toggleAll = document.getElementById('toggle_' + checkedGroup);

			if(value != "toggle-all" && event && toggleAll) {
				document.getElementById('toggle_' + checkedGroup).checked = false;
			}

			if (array) {
				let del = array.indexOf(value);
				if (del !== -1) {
					array.splice(del, 1);
				}
				updateInterface(array, parentId);
			}
		}

		function updateInterface(array, parentId) {
			let interfaceArr = [...array];
			let sumtId = "sum_group-" + parentId;
			let targetId = "display_group-" + parentId;

			if (array.length > 0) {
				document.getElementById(sumtId).classList.remove("visually-hidden");
			} else {
				document.getElementById(sumtId).classList.add("visually-hidden");
			}

			if (array.length > arrayMaxLength) {
				let calcOverhead = "+" + (interfaceArr.length - arrayMaxLength);
				interfaceArr.length = arrayMaxLength;
				interfaceArr.push(calcOverhead);
			}

			document.getElementById(targetId).innerHTML = interfaceArr.join(', ');
		}

		function showDomElement(e, state) {
			if(state === true) {
				e.classList.remove("visually-hidden");
				e.ariaHidden = "false"
			} else {
				e.classList.add("visually-hidden");
				e.ariaHidden = "true"
			}
		}

		if (currencyForm) {
			currencyForm.onclick = function (event) {
				let target = event.target;
				let selection = target.value; // set value to look for as classname
				let checkboxes = document.getElementsByClassName(selection); // find all checkboxes by selection for toggle-all
				let parentId = target.dataset.parentid;
				let checkboxValue = target.dataset.description;
				let checkboxIsChecked = target.checked;
				const submitFormBtn = document.getElementById('submit');
				const formError = document.getElementById('form-error');

				for (let checkbox of checkboxes) {
					let description = checkbox.dataset.description;
					checkbox.checked = target.checked;
					checkbox.checked ? addtoArray(description, parentId) : removefromArray(event, description, parentId);
				}

				if (checkboxIsChecked && checkboxValue && parentId) {
					showDomElement(formError, false);
					addtoArray(checkboxValue, parentId);
				} if (!checkboxIsChecked && checkboxValue && parentId) {
					removefromArray(event, checkboxValue, parentId);
				}

				if (submitFormBtn && event.target.id.toString() === "submit") {

					if(!freqDay) {  // Step 1
						if (arraysObj[1].length !== 0 || arraysObj[2].length !== 0 || arraysObj[3].length !== 0) {
							showDomElement(formError, false);
							return true;

						} else {
							showDomElement(formError, true);
							formError.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
							return false;
						}
					} else { // Step 2
						showDomElement(formError, false);

						if(isDuetDateValid()) {
							return true;
						} else {
							showDomElement(formError, true);
							formError.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
							return false;
						}
					}
				}

				if (freqDay) {
					if (freqDay && freqDay.checked) {
						/* */ // TODO: Nedan kan tas bort  om BE ändras så att checkboxar alltid är på
						for (let calculationMethod of calculationMethods) {
							calculationMethod.disabled = true;
							calculationMethod.checked = false;
						}

						showDomElement(calculationMethodElement, false)
					} else {
						/* */ // TODO: Nedan kan tas bort om BE ändras så att checkboxar alltid är på
						for (let calculationMethod of calculationMethods) {
							calculationMethod.disabled = false;
						}

						showDomElement(calculationMethodElement, true);
					}
				}

			}

			const tabs = document.querySelectorAll(".tab");
			const tabContent = document.querySelectorAll(".tabcontent");

			tabs.forEach(function (tab) {
				tab.addEventListener("click", tabClick);
			});

			function tabClick(el) {
				let tabTarget = el.currentTarget;
				let source = tabTarget.dataset.source;
				let tabTargetContent = document.querySelector("#" + source);
				const selectedClass = 'selected';

				tabs.forEach(function (el) {
					el.classList.remove(selectedClass);
					el.ariaSelected = "false";
				});

				tabContent.forEach(function (el) {
					el.classList.remove(selectedClass);
					el.ariaHidden = "true";
				});

				tabTarget.ariaSelected = "true";
				tabTarget.classList.add(selectedClass);

				tabTargetContent.classList.add(selectedClass);
				tabTargetContent.ariaHidden = "false";


			}
		}

		const separator = document.getElementById("separator");
		if (separator) {
			separator.addEventListener('click', function (event) {
				if (event.target && event.target.matches("input[type='radio']")) {
					let val = event.target.value;
					setSeparator(val);
					setDownloadLink(val)
				}
			});

			let dlLinks = document.querySelectorAll(".dl_link a");
			let cells = document.querySelectorAll(".swea-table td.res span.sep");

			function setDownloadLink(val) {
				for (let dlLink of dlLinks) {
					let getLink = dlLink.getAttribute("href");
					const newLink = val === "Dot" ? getLink.replace('Comma', 'Dot') : getLink.replace('Dot', 'Comma');
					dlLink.setAttribute("href", newLink);
				}
			}

			function setSeparator(val) {
				for (let cell of cells) {
					const separator = val === "Dot" ? "." : ",";
					cell.innerHTML = separator.toString();
				}
			}
		}
    }

	return {
		init: init
	};

})(jQuery);
